
<span v-if="model.hasMinOrMaxValue" v-html="model.valueRangeHTML"></span>
